export const extractList = <T>(response: unknown): T[] => {
  const source = response as Record<string, unknown> | null | undefined;
  const items = source?.items ?? source?.campaigns ?? source?.segments ?? source?.data;
  return Array.isArray(items) ? (items as T[]) : [];
};

export const maxBy = <T>(rows: T[], pick: (row: T) => number): number | null => {
  if (rows.length === 0) return null;
  return rows.reduce((best, row) => Math.max(best, pick(row)), Number.NEGATIVE_INFINITY);
};

export const leaderBy = <T>(rows: T[], pick: (row: T) => number): T | null => {
  if (rows.length === 0) return null;
  return rows.reduce((best, row) => (pick(row) > pick(best) ? row : best));
};